import styled from "styled-components";
export const Container = styled.div`
    height: 150px;
    text-align: center;
    background: linear-gradient(120deg, bisque, lightgreen, lightblue);
`;
export const Header = styled.h1``;
export const Title = styled.div`
    padding-top: 20px;
    color: black;
`;